import { cn } from "@shared/lib/utils";
import { Button } from "@shared/ui/button";
import { Banknote, CreditCard, FileText, Landmark, Smartphone, Receipt } from "lucide-react";

interface PaymentMethodCardProps {
  method: string;
  value: string;
  icon: "cash" | "card" | "cheque" | "bank" | "mobile" | "other";
  selected?: boolean;
  onClick: (value: string) => void;
  disabled?: boolean;
}

export function PaymentMethodCard({ method, value, icon, selected, onClick, disabled }: PaymentMethodCardProps) {
  const icons = {
    cash: Banknote,
    card: CreditCard,
    cheque: FileText,
    bank: Landmark,
    mobile: Smartphone,
    other: Receipt
  };
  
  const Icon = icons[icon];
  
  return (
    <Button
      type="button"
      variant={selected ? "default" : "outline"}
      className={cn(
        "flex flex-col items-center justify-center h-24 w-full transition-all",
        selected ? "border-2 border-primary" : "",
        disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-primary/10"
      )}
      onClick={() => onClick(value)}
      disabled={disabled}
      data-selected={selected}
    >
      <Icon className={cn("h-8 w-8 mb-2", selected ? "text-primary-foreground" : "text-primary")} />
      <span>{method}</span>
    </Button>
  );
}
